export const iconFontAwesomeShoppingKey = (
	<i className="fa-solid fa-key"></i>
);
